<template>
  <div class="top">
    <img @click="goHome" src="../assets/logo.png" id='logo' alt="logo" title='最美证件照制作' />
    <div class='tab-container'>
      <span class='tab'>证件照制作</span>
      <div style="width: 300px" />
      <img style="width: 25px" src="../assets/make/public/order-icon.png" />
      <span @click="goOrder" style="margin-left: 5px;margin-right: 20px;cursor: pointer" class='tab'>我的订单</span>
    </div>

  </div>
</template>

<script>
    export default {
        name: "PhotoMakeHeader",
        methods:{
            goOrder(){
                this.$router.push({
                    path: '/order',

                })
            },
            goHome(){
                this.$router.push({
                    path:'/home'
                })
            }
        }

    }
</script>

<style scoped>
  .top{
    position: fixed;
    top:0;
    z-index: 20;
    background:rgba(255,255,255,1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height:10%;
    padding: 0 19%;
    box-sizing: border-box;
  }
  #logo{
    width: 230px;
    flex-shrink: 0;
    flex-grow: 0;
    cursor: pointer;
  }
  .tab-container{
    display: flex;
    height: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    width: 600px;
    line-height: 90px;
    /*cursor: pointer;*/
    align-items: center;

  }
  .tab{
    display: inline-block;
    width: 70px;
    font-size: 14px;
    margin: 0 25px;
    box-sizing: border-box;
    text-align: center;
    color: #35315C;
  }
</style>
